var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesertDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1051,
    height: 529,
    viewBox: "0 0 1051 529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1286",
    x1: 0.5,
    x2: 0.5,
    y1: -0.213,
    y2: 0.994,
    gradientUnits: "objectBoundingBox",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D1C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1c0001",
    stopOpacity: 0.899
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    x2: 0.5,
    y1: -0.213,
    y2: 0.994,
    gradientUnits: "objectBoundingBox",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D1C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ef4c14",
    stopOpacity: 0.941
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1-6",
    x1: 0.5,
    x2: 0.5,
    y1: -0.213,
    y2: 0.994,
    gradientUnits: "objectBoundingBox",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D1C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000016",
    stopOpacity: 0.941
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 923.415,
    x2: 968.896,
    y1: 104.21,
    y2: 104.21,
    gradientTransform: "translate(10 -36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.624
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1231",
    x1: 128.99,
    x2: 985.764,
    y1: 547.324,
    y2: 399.686,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient-1-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1274",
    x1: 64.208,
    x2: 1856.74,
    y1: 459.01,
    y2: 560.952,
    gradientTransform: "matrix(1 0 0 .23068 0 407.903)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient1286"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1216",
    x1: 322.998,
    x2: 1409.143,
    y1: 441.975,
    y2: -232.473,
    gradientTransform: "translate(-.285 .188)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient-1-6"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter1583",
    width: 1.062,
    height: 1.039,
    x: -0.031,
    y: -0.02,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.627
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1216)",
    fillRule: "nonzero",
    d: "M0.54 1.119H1049.7549999999999V525.726H0.54z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1231)",
    fillRule: "nonzero",
    d: "M1.9152457 528.6979L1.9152457 399.3617 307.48327 382.98747 658.09729 400.59006 849.09027 372.22683 1049.3965 399.3617 1049.3965 528.6979z",
    opacity: 0.519,
    transform: "matrix(1 0 0 1.77143 0 -423.145)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1274)",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 0.083,
    d: "M.08 530.215h1049.906V512.15H.08v18.065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4682b4",
    stroke: "none",
    strokeOpacity: 1,
    strokeWidth: 1.17,
    d: "M1049.397 177.591a293.728 287.853 0 00-245.528 283.617 293.728 287.853 0 008.697 68.094h106.952a187.926 184.167 0 01-12.682-66.473 187.926 184.167 0 01142.56-178.535z",
    opacity: 0.362
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2e4d",
    stroke: "none",
    strokeOpacity: 1,
    strokeWidth: 0.78,
    d: "M6.623 349.496a195.807 191.891 0 00-6.216.305v96.58a91.337 89.51 0 014.707-.164 91.337 89.51 0 0191.166 84.808h105.623A195.807 191.891 0 006.623 349.496z",
    opacity: 0.378
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4682b4",
    stroke: "none",
    strokeOpacity: 1,
    d: "M122.027 1.263A252.007 246.966 0 01-.085 146.883v149.411A393.886 386.008 0 00271.01 1.263z",
    opacity: 0.349
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1583)",
    opacity: 0.208,
    transform: "matrix(.26282 0 0 .26282 395.117 83.031)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#007dbd",
    d: "M799.2 728.8c20.4 0 39.6 19.6 35.7 40.8-1.9 10.1-2 21.1-20.4 30.5-9.1 4.6-10.5 15.1-10.5 23.2h-12v-8.2c0-7.3-4.9-10.7-10.2-15.2-11.5-9.9-18.9-17.4-20.3-30.5-1.3-10.7 1-16.5 10.2-30.5-113.9-69.1-209-127.9-291.8-176.6l8-13.5c110.1 64.9 251.1 148.7 296 175 4.9 2.8 9.7 5 15.3 5zm1.6 52.1c8-.1 16.1-7.8 16.1-15.6 0-7.9-7.6-15-16.1-15-8.6.1-16 6.9-16 15 0 7.9 7.9 15.6 16 15.6z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007dbd",
    d: "M814.5 861.3c20.4 11.3 29.7 40.3 15.2 56-11.3 12.2-18.2 16.2-35.6 15.3-20.6-1.1-20.1-16-30.5-10.2-6.8 3.8-422.1 215.2-590.8 305.6-9.3 5-1.1 25.6-20.4 35.7-20.6 10.7-46.4 4.4-56.1-10.2-10.1-15.2-10.9-38 10.2-56 10.8-9.2 10.2-22 10.2-30.5v-61.1c0-6.7-3.1-9.3-9.1-13.1-17.6-10.9-22.6-30.2-16.4-48.1 5.8-16.9 16.7-23.1 30.5-25.5 17.9-3 26.9.5 40.8 10.2 6.3 4.4 417.7-178 437.2-193.7 5.1-4.2 8.6-8.5 11-20.2 1.5-7.4 1.4-18.3-5.6-23.5-63.3-48.6-310.1-185.4-401.8-241.4-5.1-3.1-25.5-5.1-30.5-10.2-19.6-19.3-16.7-43.7 5.1-61.1 5-4 10.2-5.4 10.2-15.2 0-15.3.5-31.3 0-50.9-.1-3.9-6.9-8.7-10.2-10.2-31.7-15-20.6-71.4 20.4-71.3 15.2.1 22.1 7.9 30.5 5.1 15.3-5.1 350.6-172.7 436.5-211.3 6.2-2.8 11.1-12.7 11.7-13.9 15.3-30.5 64.6-24.7 71.3 10.2 4.2 21.9-3.2 29.3-20.4 45.8-2.5 2.4-5.1 10.2-4.7 16.1-.5 22.9-.5 57.2 0 80.2.2 6.1-1 7.3 4.7 11.7 9.8 7.5 22.1 16.4 22.1 32.8 0 15.4-9.1 42.2-37.4 43.6-26.5 1.3-33.6-17-35.6-20.4-1.6-2.6-13.1 2.1-20.4 5.1-61.1 25.5-254.7 107-272 117.5-10 6.1-22.8 20.9 2.1 35.3 25.7 14.9 61.5 35.9 101.2 59.3l-8 13.5c-39.1-23.1-75.5-43.8-109.8-62.3-14.3 8-25.5 10.4-40.7 5.1-23.7-8.3-31.8-36.9-17.3-58.2 12.5-18.1 36.2-18.4 57.9-7.9 5 2.4 306.5-132.5 304.9-132.2 1.4-7.2 3.2-25 30.5-35.6V168.4c-14.3-3.4-26.3-17.1-30.5-25.4-.5-1.1-336.4 160.5-437.3 212.3-3.1 1.6 4.6 18.5.2 27.7-6.7 13.6-13.4 17.5-20.3 20.3-2.5 1-5 2.8-5.1 5.1-.6 21.9-2.2 36.4 0 66.1 15.8 6 31.3 20.3 30.5 35.6-.9 17.4-4.4 19.6-15.2 30.5 1 1.6 304.9 177.9 401.5 238.9 3.2 2 11.2 1 15.2 0 9.6-2.5 20.6-1.7 25.4 0 17.9 6.5 33.1 23.3 25.4 50.8-6.3 22.5-36.2 33.2-56.3 23.9-3.6-1.6-16.7-5.1-19.9-3.6-37.9 17.5-294.8 132.2-442.2 198.2-4.5 2 5.1 25.4-25.4 45.7-3.8 2.6-9.9 3.6-10.2 10.2-.9 21.9 0 59.4 0 81.4 0 5.1 5.1 10.2 15.2 15.2 6.6 3.2 15.7 4.6 15.7 4.6 71.2-35.6 589.2-299 589.2-309.6 0-20.8 9.6-29 25.4-40.7 2.8-2 5.1-6.4 5.1-10.2v-22.3h12c0 2.9.2 5.5.3 7.4.6 10.4-3.1 23.3 10.4 30.8zm2.3 33.5c.3-7.5-7.6-15.6-15.6-15.9-7.9-.3-16.2 7.2-16.5 15-.3 7.7 7.4 15.7 15.5 16 8 .2 16.3-7.3 16.6-15.1zm-86.6-583.9c.1-7.7-8-15.7-15.9-15.8-8-.1-16.1 7.6-16.1 15.5-.1 7.9 7.4 15.2 15.8 15.2 8.3 0 16.1-7.1 16.2-14.9zm0-179.6c-.1-7.6-8.4-15.8-16-15.8-7.8.1-16 8.1-16 15.8-.1 7.3 8.6 16.1 16 16.1 7.2 0 16-8.8 16-16.1zm-74.5 701.8c8.2-.2 15.5-7.6 15.4-15.9 0-7.6-8-15.5-15.6-16.1-7.8-.7-17.2 8-16.3 16.7.7 7.5 8.9 15.4 16.5 15.3zM358.9 467.8c.1-8.3-7.4-15.7-15.5-15.6-7.8.1-15 7.1-15.3 14.9-.4 8.7 6.2 15.6 15 15.7 9.2.1 15.8-6.2 15.8-15zM216.4 511c.1-8.4-7-15.3-15.6-15.4-8.3-.1-16.1 7-16.4 14.8-.3 7.9 8.5 16.8 16.3 16.6 7.6-.1 15.7-8.4 15.7-16zm-.4-141.9c.1-7.7-7.9-15.7-15.8-15.8-8.1-.1-16.1 7.6-16.2 15.5-.1 7.9 7.4 15.2 15.8 15.2s16.2-7.1 16.2-14.9zm-65.9 863.2c.9-8.4-6.3-16.7-15-17.4-7.6-.6-16.6 6.8-17 14.4-.5 9.1 6.7 16.8 14.6 16.9 7.9.1 16.6-6.1 17.4-13.9zm-15.4-160c9.2-.2 15.8-6.7 15.5-15.4-.3-8.4-7.9-15.5-16.3-15.1-8.4.3-16 8.1-15.7 16 .2 8.2 7.5 14.6 16.5 14.5z",
    className: "st4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesertDark);
export default __webpack_public_path__ + "static/media/desert-dark.e23baacf34a49b36203322699bca29c9.svg";
export { ForwardRef as ReactComponent };